exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.percent-text {\n  color: #E5DDF2;\n  font-size: 20px !important;\n  text-align: center;\n  margin-left: 10px;\n}\n.vue-progress-path {\n  margin-left: 150px;\n}\n", "", {"version":3,"sources":["/var/lib/jenkins/workspace/tms-docker-build/frontend/shipper/src/components/dashboard/Dispatched.vue"],"names":[],"mappings":";AACA;EACE,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;CACnB;AACD;EACE,mBAAmB;CACpB","file":"Dispatched.vue","sourcesContent":["\n.percent-text {\n  color: #E5DDF2;\n  font-size: 20px !important;\n  text-align: center;\n  margin-left: 10px;\n}\n.vue-progress-path {\n  margin-left: 150px;\n}\n"],"sourceRoot":""}]);

// exports
